import React from 'react'

export default function BrowserCompatibility() {
  return (
    <section><a className="anchor" id="browserCompatibility"></a>
    <div className="grid content--middle">
      <div className="grid__col-md-12 grid__col--bleed">
        <div className="grid">
          <div className="swatch-card grid__col-sm-3 text--center grid--justify-center" style={{"backgroundColor":"#5CA446"}}>
            <h1 className="flush">IE 10 +</h1>
          </div>
          <div className="swatch-card grid__col-sm-3 text--center grid--justify-center" style={{"backgroundColor":"#52933f"}}>
            <h1 className="flush">Chrome 50 +</h1>
          </div>
          <div className="swatch-card grid__col-sm-3 text--center grid--justify-center" style={{"backgroundColor":"#498338"}}>
            <h1 className="flush">Firefox 46 +</h1>
          </div>
          <div className="swatch-card grid__col-sm-3 text--center grid--justify-center" style={{"backgroundColor":"#407231"}}>
            <h1 className="flush">Safari 9.3 +</h1>
          </div>
        </div>
      </div>
    </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/BrowserCompatibility.js